module.exports = [{
      plugin: require('/Users/Moniet97/Dropbox/Programming/Web_Design/moniet.github.io/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/Moniet97/Dropbox/Programming/Web_Design/moniet.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
